import { ROUTE_UI_SECTION_NAME } from '../../constants/route'
import { LANDLORD_USER_ROLE } from '../../constants/user'
import { getSectionCanViewPermission } from '../../utils/common'

import {
  BIRDVIEW_DEFAULT_ROLE,
  BIRDVIEW_GREETING_AFTERNOON_HOUR,
  BIRDVIEW_GREETING_EVENING_HOUR,
  BIRDVIEW_ROLES,
  BirdviewScope,
  BirdviewSkeleton,
  BirdviewView,
} from './DashboardBirdview.constants'
import { BirdviewAnalyticsPreset } from './DashboardBirdview.constants.charts'

// The /dashboard preview of a portal without the dashboard shows Analytics too.
function checkIsBirdviewAnalyticsSectionOn(availableSections) {
  return (
    availableSections[ROUTE_UI_SECTION_NAME.dashboardAnalytics] ||
    !availableSections[ROUTE_UI_SECTION_NAME.dashboard]
  )
}

export function checkIsBirdviewOversightSkeleton(role) {
  return role.skeleton === BirdviewSkeleton.Oversight
}

export function checkIsBirdviewDwellerSkeleton(role) {
  return role.skeleton === BirdviewSkeleton.Dweller
}

export function checkIsBirdviewLandlordRole(role) {
  return role.value === LANDLORD_USER_ROLE
}

export function checkIsBirdviewTeamScope(scope) {
  return scope === BirdviewScope.Team
}

export function checkIsBirdviewAnalyticsView(view) {
  return view === BirdviewView.Analytics
}

export function checkIsBirdviewAnalyticsAvailable({
  availableSections,
  role,
  sectionsPermissions,
}) {
  return (
    !checkIsBirdviewDwellerSkeleton(role) &&
    checkIsBirdviewAnalyticsSectionOn(availableSections) &&
    getSectionCanViewPermission(
      sectionsPermissions,
      ROUTE_UI_SECTION_NAME.dashboardAnalytics
    )
  )
}

export function checkIsBirdviewDocFlowsViewable(sectionsPermissions) {
  return getSectionCanViewPermission(
    sectionsPermissions,
    ROUTE_UI_SECTION_NAME.docFlows
  )
}

export function checkIsBirdviewChatsViewable(sectionsPermissions) {
  return getSectionCanViewPermission(
    sectionsPermissions,
    ROUTE_UI_SECTION_NAME.chats
  )
}

export function checkIsBirdviewDwellerDocumentsViewable(sectionsPermissions) {
  return getSectionCanViewPermission(
    sectionsPermissions,
    ROUTE_UI_SECTION_NAME.documentsDweller
  )
}

export function checkIsBirdviewInhabitantsViewable(sectionsPermissions) {
  return getSectionCanViewPermission(
    sectionsPermissions,
    ROUTE_UI_SECTION_NAME.inhabitants
  )
}

export function getBirdviewGreetingKey(date) {
  const hour = date.getHours()

  if (hour < BIRDVIEW_GREETING_AFTERNOON_HOUR) {
    return 'DashboardBirdview.GreetingMorningKey'
  }

  if (hour < BIRDVIEW_GREETING_EVENING_HOUR) {
    return 'DashboardBirdview.GreetingAfternoonKey'
  }

  return 'DashboardBirdview.GreetingEveningKey'
}

export function getBirdviewRole(userRole) {
  return (
    BIRDVIEW_ROLES.find(role => role.value === userRole) ??
    BIRDVIEW_ROLES.find(role => role.value === BIRDVIEW_DEFAULT_ROLE)
  )
}

export function getBirdviewAnalyticsPreset(role) {
  return checkIsBirdviewOversightSkeleton(role)
    ? BirdviewAnalyticsPreset.Portfolio
    : BirdviewAnalyticsPreset.Personal
}

export function getBirdviewEffectiveScope({ role, scope }) {
  return checkIsBirdviewOversightSkeleton(role) ? scope : BirdviewScope.Mine
}

export function getBirdviewEffectiveView({ isAnalyticsAvailable, view }) {
  return isAnalyticsAvailable ? view : BirdviewView.Dashboard
}
